module.exports = __webpack_public_path__ + "static/media/5160998.8fd3196b.jpg";